<template>
    <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <div class="modal-card-title">
                <p>
                    <b-icon icon="road" class="m-2"></b-icon>
                    {{ fm }}
                </p>
                <div class="field has-text-right">
                    <b-tag type="is-info">{{ uuid }}</b-tag>
                </div>
            </div>
        </header>
        <section class="modal-card-body">

            <b-field label="Nombre"
                v-if="this.isUnit">
                <b-input type="number" min="0" v-model="nbunitsSaisie">
                </b-input>
            </b-field>

            <b-field label="Somme"
                v-if="!this.isUnit">
                <b-input type="number" min="0" step="0.01" v-model="costSaisie">
                </b-input>
            </b-field>

            <b-field label="Coût"
                     v-if="updateCost">
                {{ updateCost }} €
            </b-field>

            <b-field label="N° devis">
                <b-input type="text" v-model="devisSaisie" placeholder="N° de devis">
                </b-input>
            </b-field>

            <b-field label="Commentaire">
                <b-input type="text" v-model="commentSaisie" placeholder="Commentaire">
                </b-input>
            </b-field>


        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.close()">
                Annuler
            </button>
            <button class="button is-primary" @click="editTodo">Enregistrer</button>
        </footer>
    </div>
</template>

<script>
    export default {
        name: "FMEditModal",
        props: {
            refFrais: {
                type: Array,
                required: true
            },
            nbunits: {
                // type: Number,
                required: true
            },
            cost: {
                type: Number,
                required: true
            },
            comment: {
                // type: String,
                required: true
            },
            devis: {
                // type: String,
                required: true
            },
            fm: {
                type: String,
                required: true
            },
            uuid: {
                type: String,
                required: true
            },
        },
        data() {
            return {
                isUnit: null,
                costSaisie: null,
                nbunitsSaisie: 0,
                commentSaisie: '',
                devisSaisie: '',
            }
        },
        mounted() {
            this.nbunitsSaisie = this.nbunits;
            this.isUnit = !!this.nbunitsSaisie;
            this.costSaisie = this.cost;
            this.devisSaisie = this.devis;
            this.commentSaisie = this.comment;
        },
        computed: {
            updateCost() {
                if (this.fm && this.nbunitsSaisie) {
                    const f = this.refFrais.find(element => element.lib === this.fm);
                    return f.unit ? f.unitCost * this.nbunitsSaisie : null;
                } else {
                    return null;
                }
            }
        },
        methods: {
            editTodo() {
                if (parseInt(this.nbunitsSaisie) >= 1 ) {
                    this.nbunitsSaisie = Math.round(this.nbunitsSaisie)
                    const payload = {
                        uuid: this.uuid,
                        fm: this.fm,
                        nbunits: this.nbunitsSaisie,
                        cost: this.updateCost,
                        devis: this.devisSaisie,
                        comment: this.commentSaisie
                    };
                    this.$emit("edit-fm", payload);
                } else if (parseInt(this.costSaisie)) {
                    const payload = {
                        uuid: this.uuid,
                        fm: this.fm,
                        nbunits: null,
                        cost: parseFloat(this.costSaisie),
                        devis: this.devisSaisie,
                        comment: this.commentSaisie
                    };
                    this.$emit("edit-fm", payload);
                }
                else {
                    this.$buefy.snackbar.open(
                        {
                            message: `Mauvaise saisie, merci de vérifier`,
                            type: 'is-danger',
                            position: 'is-bottom-left'
                        });
                }
            }
        }
    };
</script>

<style scoped></style>
